// MVP: usa um estabelecimento fixo via VITE_DEFAULT_ESTABELECIMENTO_ID,
// com fallback para o estabelecimento de demonstração seedado.
// TODO: detectar pelo subdomínio (ex.: pedrodetoledo.pontisistemas.com.br).

const FALLBACK = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';

export function getEstabelecimentoAtualId(): string {
  return import.meta.env.VITE_DEFAULT_ESTABELECIMENTO_ID ?? FALLBACK;
}

/**
 * Centro padrão dos mapas (sede do município) quando ainda não há pinos/seleção.
 * Sede de Pedro de Toledo/SP. Ajuste por deploy via VITE_MAPA_CENTRO="lat,lng".
 */
export function getCentroMapaPadrao(): [number, number] {
  const env = import.meta.env.VITE_MAPA_CENTRO as string | undefined;
  if (env) {
    const [lat, lng] = env.split(',').map((n) => Number(n.trim()));
    if (Number.isFinite(lat) && Number.isFinite(lng)) return [lat, lng];
  }
  return [-24.2769, -47.2306];
}
